<nz-table [nzNoResult]="undefined" [nzData]="[1]" [nzShowPagination]="false">
    <thead>
        <tr>
            <th>{{"Common.Language" | translate}}</th>
            <th>{{"Common.Text" | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let cul of cultures">
            <td>{{tanslate(cul) | async}}</td>
            <td><input type="text" nz-input [ngModel]="getText(cul)" (ngModelChange)="setText(cul,$event)"></td>
        </tr>
    </tbody>
</nz-table>